import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add station API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  addGuestCharging: (data: any): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/facility/v1/free-charging`, data, false);
  },
  /**
   * Fetch stations API
   * @param query
   */
  fetchGuestCharging: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/facility/v1/free-charging`, {
      ...parameters,
    });
  },
  /**
   * Fetch stations API for export
   * @param query
   */
  fetchGuestChargingExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/facility/v1/free-charging/export-data`, {
      ...parameters,
    });
  },
  /**
   * Edit station API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  historyGuestCharging: (id: string): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/free-charging/history-list/${id}`, {});
  },
  /**
   * Edit station API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editGuestCharging: (id: string, data: any): Promise<any> => {
    return patchRequest(`${config.commonApiUrl}api/facility/v1/free-charging/${id}`, data, false);
  },
  /**
   * Edit station status API
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  editGuestChargingStatus: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/status/${id}`,
      data,
      false,
    );
  },
  /**
   * Delete Station API
   * @param id
   */
  deleteGuestCharging: (id: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/facility/v1/free-charging/${id}`);
  },

  /**
   * Fetch guest charging API
   * @returns
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/free-charging/list-filters`);
  },

  /**
   *updating guest status
   * @returns
   */
  updateGuestStatus: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/free-charging/updateActiveStatus/${id}`,
      data,
      false,
    );
  },
  /**
   * Fetch guest details API
   * @param guestId - Guest ID
   */
  fetchGuestDetails: (guestId: string) => {
    return getRequest(`${config.reportApiUrl}api/facility/v1/free-charging/${guestId}`);
  },
};
